import { useQuery } from '@apollo/client';
import GET_DRIVER from '../Driver.Queries';

export function useDriver(id: string) {
  return useQuery(GET_DRIVER, { variables: { id } });
}
